/**
 * Lê parâmetros de atribuição (Google Ads, Meta, UTM) da query string.
 * @param {string} search — ex.: window.location.search
 */
export function readAcquisitionFromUrl(search) {
  const sp = new URLSearchParams(String(search || ""));
  const pick = (k) => {
    const v = sp.get(k);
    return v != null && String(v).trim() !== "" ? String(v).trim() : undefined;
  };
  const out = {
    utm_source: pick("utm_source"),
    utm_medium: pick("utm_medium"),
    utm_campaign: pick("utm_campaign"),
    utm_term: pick("utm_term"),
    utm_content: pick("utm_content"),
    gclid: pick("gclid"),
    fbclid: pick("fbclid"),
  };
  if (typeof window !== "undefined") {
    out.landing_path = `${window.location.pathname}${window.location.search}`.slice(0, 512);
  }
  return out;
}

/**
 * Plano, modo (trial|pay) e audiência a partir da URL de campanha.
 * @param {string} search
 */
export function readSignupFunnelParams(search) {
  const sp = new URLSearchParams(String(search || ""));
  const plan = sp.get("plan") || sp.get("planSku");
  const modeRaw = (sp.get("mode") || "trial").toLowerCase();
  const mode = modeRaw === "pay" ? "pay" : "trial";
  const audRaw = (sp.get("audience") || "end_customer").toLowerCase();
  const audience = audRaw === "reseller" ? "reseller" : "end_customer";
  const partnerToken = sp.get("partnerToken") || sp.get("partner_token");
  return {
    plan: plan && String(plan).trim() ? String(plan).trim().toLowerCase() : null,
    mode,
    audience,
    partnerToken: partnerToken && String(partnerToken).trim() ? String(partnerToken).trim() : null,
  };
}
